import React, { Component } from 'react';
import './App.css';
import './animate.css';
import { Icon } from 'semantic-ui-react';
import LazyLoad from 'react-lazyload';
import EventCards from './Components/EventCards';
import SportsGrid from './Components/SportsGrid';
import SingleEvent from './Components/SingleEvent';
import Header from './Components/Header';
import Leaderboard from './Components/Leaderboard';
import Footer from './Components/Footer';
class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="scroll-wrap">
          <div id="select-sport" className="animated slideInLeft">
            <SportsGrid />
          </div>
          <div id="select-match">
            <LazyLoad>
              <EventCards />
            </LazyLoad>
          </div>
          <div id="select-winner">
            <SingleEvent />
          </div>
          <div id="leaders">
            <Leaderboard />
          </div>
          <div id="footer">
            <Footer />
          </div>
        </div>
        <div id="snackbar-green">Bet Successfully made! <span id="snackbar-close"><Icon name="close" /></span></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js